import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    draftMailTypesData: {},
};

const draftMailSlice = createSlice({
    name: 'draftMailTypes',
    initialState,
    reducers: {
        setDraftMailTypesData(state, { payload }) {
            state.draftMailTypesData = payload;
        },
        getDraftMailTypesData() {},
    },
});

export const draftMailActions = draftMailSlice.actions;
export const draftMailReducer = draftMailSlice.reducer;
